import { Divider, VStack, DataList } from '@cad-arc';
import { SearchVehicleForm } from '@mark43/cad-api';
import { intersperse } from '../common/helpers/intersperse';
import { FilterSummary } from './filter-summary';
import { FiltersSummary } from './filters-summary';

export function VehicleInformationFiltersSummary({
    hasHeldTowVehicle,
    hasReleasedTowVehicle,
    vehicles,
}: {
    vehicles: SearchVehicleForm[];
    hasHeldTowVehicle?: boolean;
    hasReleasedTowVehicle?: boolean;
}) {
    if (vehicles.length === 0 && !hasHeldTowVehicle && !hasReleasedTowVehicle) {
        return null;
    }
    return (
        <FiltersSummary title="Vehicle Information">
            <VStack align="left" gap="2px">
                {intersperse(
                    vehicles.map((vehicle, index) => (
                        <DataList key={index}>
                            <FilterSummary label="Plate #" stringValue={vehicle.plateNumber} />
                            <FilterSummary label="Plate State" option={vehicle.state} />
                            <FilterSummary label="VIN" stringValue={vehicle.vinNumber} />
                            <FilterSummary label="Color" option={vehicle.color} />
                            <FilterSummary label="Make" option={vehicle.vehicleMake} />
                            <FilterSummary
                                label="Make Description"
                                stringValue={vehicle.vehicleMakeOther}
                            />
                            <FilterSummary label="Model" option={vehicle.vehicleModel} />
                            <FilterSummary
                                label="Model Description"
                                stringValue={vehicle.vehicleModelOther}
                            />
                            <FilterSummary label="Year" numberValue={vehicle.year} />
                            <FilterSummary label="Notes" stringValue={vehicle.notes} />
                            <FilterSummary
                                label="Involvement Type"
                                option={vehicle.involvementType}
                            />
                            <FilterSummary
                                label="Involvement Type Description"
                                stringValue={vehicle.involvementTypeOther}
                            />
                            <FilterSummary label="Tow Type" stringValue={vehicle.towType} />
                        </DataList>
                    )),
                    <Divider />
                )}

                <FilterSummary
                    label="Has Currently Held Tow Vehicle"
                    key="Has Currently Held Tow Vehicle"
                    booleanValue={hasHeldTowVehicle}
                />

                <FilterSummary
                    label="Has Currently Released Tow Vehicle"
                    key="Has Currently Released Tow Vehicle"
                    booleanValue={hasReleasedTowVehicle}
                />
            </VStack>
        </FiltersSummary>
    );
}
